import { useState, useEffect } from 'react'

const API = '/cms/api/institutions'

export default function InstMiniappConfigPage() {
  const [institutions, setInstitutions] = useState([])
  const [selectedId, setSelectedId] = useState('')
  const [config, setConfig] = useState(null)
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState('')

  // 加载机构列表
  useEffect(() => {
    fetch(`${API}?status=active&_t=${Date.now()}`)
      .then(r => r.json())
      .then(d => {
        const list = d.data || d || []
        setInstitutions(list)
        if (list.length > 0 && !selectedId) setSelectedId(list[0].id)
      })
      .catch(() => setMessage('加载机构列表失败'))
  }, [])

  // 加载选中机构的小程序配置
  useEffect(() => {
    if (!selectedId) return
    setLoading(true)
    fetch(`${API}/${selectedId}/miniapp-config`)
      .then(r => r.json())
      .then(d => {
        if (d.success) setConfig(d.data)
        else setConfig(null)
        setLoading(false)
      })
      .catch(() => { setConfig(null); setLoading(false) })
  }, [selectedId])

  // 保存配置
  const saveConfig = async (field, value) => {
    setSaving(true)
    try {
      const r = await fetch(`${API}/${selectedId}/miniapp-config`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ [field]: value })
      })
      const d = await r.json()
      if (d.success) {
        setConfig(d.data)
        setMessage('✅ 已保存')
      } else {
        setMessage('❌ 保存失败: ' + (d.error || ''))
      }
    } catch {
      setMessage('❌ 网络错误')
    }
    setSaving(false)
    setTimeout(() => setMessage(''), 3000)
  }

  const toggle = (field) => {
    saveConfig(field, !config?.[field])
  }

  const saveText = (field, value) => {
    saveConfig(field, value)
  }

  const selStyle = { width: '100%', maxWidth: 400, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, marginBottom: 20 }
  const switchRow = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #f0f0f0' }
  const switchTrack = (on) => ({ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: on ? '#52c41a' : '#ccc', borderRadius: 12, transition: '0.3s' })
  const switchKnob = (on) => ({ position: 'absolute', top: 2, left: on ? 22 : 2, width: 20, height: 20, background: '#fff', borderRadius: '50%', transition: '0.3s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' })

  const inst = institutions.find(i => i.id === selectedId)

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ margin: '0 0 8px' }}>🏪 机构小程序配置</h2>
      <p style={{ color: '#666', marginBottom: 20, fontSize: 14 }}>选择机构后管理其小程序功能开关与参数</p>

      {message && (
        <div style={{ padding: '10px 16px', background: message.startsWith('✅') ? '#f6ffed' : '#fff2e8', border: `1px solid ${message.startsWith('✅') ? '#b7eb8f' : '#ffbb96'}`, borderRadius: 6, marginBottom: 16, color: message.startsWith('✅') ? '#389e0d' : '#d46b08' }}>
          {message}
        </div>
      )}

      <select value={selectedId} onChange={e => setSelectedId(e.target.value)} style={selStyle}>
        {institutions.map(i => (
          <option key={i.id} value={i.id}>{i.name || i.id} ({i.id})</option>
        ))}
      </select>

      {loading && <div style={{ color: '#999', padding: 20 }}>加载中...</div>}

      {!loading && config && (
        <div style={{ background: '#fff', borderRadius: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
          {/* 机构信息 */}
          {inst && (
            <div style={{ ...switchRow, background: '#fafafa' }}>
              <div>
                <div style={{ fontWeight: 600 }}>{inst.name || inst.id}</div>
                <div style={{ fontSize: 12, color: '#888' }}>ID: {inst.id}</div>
              </div>
              <div style={{ fontSize: 12, color: '#888' }}>
                最后更新: {config.updated_at || '未知'}
              </div>
            </div>
          )}

          {/* 小程序皮肤模式（v3 §1.4 label_mode · 小套 2026-09-06 补 CMS 配置入口） */}
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0f0f0', background: '#fffbe6' }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>🎨 小程序皮肤模式</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 10 }}>教育=存量机构零变化（称谓机构/校长/老师）；企业=企业大脑（称谓企业/企业主/员工 + 行业金刚区）。默认教育，保护存量。</div>
            <div style={{ display: 'flex', gap: 8 }}>
              {[['education', '🏫 教育机构'], ['enterprise', '🏢 企业大脑']].map(([v, txt]) => {
                const cur = config?.label_mode || 'education'
                const on = cur === v
                return (
                  <button key={v} disabled={saving} onClick={() => saveConfig('label_mode', v)}
                    style={{ padding: '8px 18px', borderRadius: 6, fontSize: 14, cursor: saving ? 'wait' : 'pointer', border: `1px solid ${on ? '#1890ff' : '#d9d9d9'}`, background: on ? '#e6f7ff' : '#fff', color: on ? '#1890ff' : '#333', fontWeight: on ? 600 : 400 }}>
                    {txt}{on ? ' ✓' : ''}
                  </button>
                )
              })}
            </div>
          </div>

          {/* 行业皮肤（企业模式下决定首页金刚区，对应 home-dock.js 门控③） */}
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>🏷️ 行业皮肤（企业模式金刚区）</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 10 }}>企业模式下决定首页金刚区模板；未设置=不渲染金刚区（防误伤）</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {[['', '未设置'], ['beauty', '💅 美业'], ['health', '🌿 大健康'], ['travel', '🧳 文旅'], ['catering', '🍜 餐饮']].map(([v, txt]) => {
                const cur = config?.industry || ''
                const on = cur === v
                return (
                  <button key={v || 'none'} disabled={saving} onClick={() => saveConfig('industry', v)}
                    style={{ padding: '8px 18px', borderRadius: 6, fontSize: 14, cursor: saving ? 'wait' : 'pointer', border: `1px solid ${on ? '#1890ff' : '#d9d9d9'}`, background: on ? '#e6f7ff' : '#fff', color: on ? '#1890ff' : '#333', fontWeight: on ? 600 : 400 }}>
                    {txt}{on ? ' ✓' : ''}
                  </button>
                )
              })}
            </div>
          </div>

          {/* 版本（standard/custom，与行业组合选金刚区模板） */}
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>📦 版本</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 10 }}>standard=标准版（4 行业模板）；custom=定制版（独立品牌）</div>
            <div style={{ display: 'flex', gap: 8 }}>
              {[['standard', '标准版'], ['custom', '定制版']].map(([v, txt]) => {
                const cur = config?.version || 'standard'
                const on = cur === v
                return (
                  <button key={v} disabled={saving} onClick={() => saveConfig('version', v)}
                    style={{ padding: '8px 18px', borderRadius: 6, fontSize: 14, cursor: saving ? 'wait' : 'pointer', border: `1px solid ${on ? '#1890ff' : '#d9d9d9'}`, background: on ? '#e6f7ff' : '#fff', color: on ? '#1890ff' : '#333', fontWeight: on ? 600 : 400 }}>
                    {txt}{on ? ' ✓' : ''}
                  </button>
                )
              })}
            </div>
          </div>

          {/* 首页视频样片 */}
          <div style={switchRow}>
            <div>
              <div style={{ fontWeight: 500 }}>🎬 首页动画影片样片</div>
              <div style={{ fontSize: 13, color: '#888' }}>控制该机构小程序首页视频样片区显示/隐藏</div>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', width: 44, height: 24, cursor: saving ? 'wait' : 'pointer' }}>
              <input type="checkbox" checked={!!config.enableVideoShowcase} onChange={() => toggle('enableVideoShowcase')} disabled={saving} style={{ display: 'none' }} />
              <span style={switchTrack(config.enableVideoShowcase)}></span>
              <span style={switchKnob(config.enableVideoShowcase)}></span>
            </label>
          </div>

          {/* 故事详情页视频 */}
          <div style={switchRow}>
            <div>
              <div style={{ fontWeight: 500 }}>🌈 七彩谷故事详情页视频</div>
              <div style={{ fontSize: 13, color: '#888' }}>控制该机构七彩谷故事详情页底部视频播放器显示/隐藏</div>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', width: 44, height: 24, cursor: saving ? 'wait' : 'pointer' }}>
              <input type="checkbox" checked={!!config.enableStoryVideo} onChange={() => toggle('enableStoryVideo')} disabled={saving} style={{ display: 'none' }} />
              <span style={switchTrack(config.enableStoryVideo)}></span>
              <span style={switchKnob(config.enableStoryVideo)}></span>
            </label>
          </div>

          {/* AI创作入口 */}
          <div style={switchRow}>
            <div>
              <div style={{ fontWeight: 500 }}>🤖 AI创作入口</div>
              <div style={{ fontSize: 13, color: '#888' }}>控制该机构小程序AI创作功能是否对用户开放</div>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', width: 44, height: 24, cursor: saving ? 'wait' : 'pointer' }}>
              <input type="checkbox" checked={config.aiCreationEnabled !== false} onChange={() => toggle('aiCreationEnabled')} disabled={saving} style={{ display: 'none' }} />
              <span style={switchTrack(config.aiCreationEnabled !== false)}></span>
              <span style={switchKnob(config.aiCreationEnabled !== false)}></span>
            </label>
          </div>

          {/* 七彩谷入口 */}
          <div style={switchRow}>
            <div>
              <div style={{ fontWeight: 500 }}>📚 七彩谷入口</div>
              <div style={{ fontSize: 13, color: '#888' }}>控制该机构小程序七彩谷故事入口显示/隐藏</div>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', width: 44, height: 24, cursor: saving ? 'wait' : 'pointer' }}>
              <input type="checkbox" checked={config.showQicaiGu !== false} onChange={() => toggle('showQicaiGu')} disabled={saving} style={{ display: 'none' }} />
              <span style={switchTrack(config.showQicaiGu !== false)}></span>
              <span style={switchKnob(config.showQicaiGu !== false)}></span>
            </label>
          </div>

          {/* 公告 */}
          <div style={{ padding: '16px 20px' }}>
            <div style={{ fontWeight: 500, marginBottom: 8 }}>📢 首页公告</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                type="text"
                value={config.announcement || ''}
                onChange={e => setConfig({ ...config, announcement: e.target.value })}
                onBlur={() => saveText('announcement', config.announcement || '')}
                placeholder="留空则不显示公告"
                style={{ flex: 1, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}
              />
            </div>
          </div>

          {/* 联系电话 */}
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ fontWeight: 500, marginBottom: 8 }}>📞 联系电话</div>
            <input
              type="text"
              value={config.contact_phone || ''}
              onChange={e => setConfig({ ...config, contact_phone: e.target.value })}
              onBlur={() => saveText('contact_phone', config.contact_phone || '')}
              placeholder="用户端显示的联系电话"
              style={{ width: '100%', maxWidth: 300, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}
            />
          </div>
        </div>
      )}

      {!loading && !config && selectedId && (
        <div style={{ color: '#999', padding: 40, textAlign: 'center', background: '#fff', borderRadius: 8 }}>
          该机构暂无小程序配置数据
        </div>
      )}
    </div>
  )
}
